import PropTypes from 'prop-types';

export default {
  isUsersDataLoading: PropTypes.bool,
  users: PropTypes.arrayOf(PropTypes.shape({
    disabled: PropTypes.number,
    email: PropTypes.string,
    firstName: PropTypes.string,
    id: PropTypes.number,
    lastName: PropTypes.string,
    projectId: PropTypes.number,
    devices: PropTypes.number
  }))
};
